export const linkRoutes = {
  home: "https://konnectx.us/",
  aboutUs: "https://www.konnectx.us/about-us",
  packages: "https://www.konnectx.us/packages",
  services: "https://www.konnectx.us/services",
};

export const routesPages = [
  "/",
  "/about-us",
  "/packages",
  "/services",
  "/terms-and-conditions",
  "/privacy-policy",
  "/data-policy",
  "/cookies-policy",
];

export const noIndexRoutes = [
  "*",
  "/blogs/:blog",
  "/terms-and-conditions",
  "/privacy-policy",
  "/data-policy",
  "/cookies-policy",
];
